import { ReactNode } from "react";
import { Box, Card, CardHeader, Link, Typography } from "@mui/material";
import { colors, radius, shadows } from "../../data/tokens";

// Casca das telas públicas de acesso (login, recuperar senha, sucesso do
// cadastro): cartão centralizado sobre o navy da marca, com o logotipo no
// topo. Espelha o visual do LoginPage para as telas de "portão" ficarem
// idênticas — sem o menu lateral do painel, que não faz sentido para quem
// ainda não entrou.
export const PublicAuthShell = ({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: colors.primaryDark,
      padding: 3,
    }}
  >
    <Card
      sx={{
        width: "100%",
        maxWidth: 430,
        borderRadius: `${radius.lg}px`,
        boxShadow: shadows.card,
      }}
    >
      <Box sx={{ textAlign: "center", pt: 4, px: 4 }}>
        <img
          src="/logo-horizontal.svg"
          alt="Clube de Engenharia"
          style={{ maxWidth: 280, width: "100%" }}
        />
      </Box>
      {/* px alinhado com o corpo do formulário (32px) — sem ele o
          subtítulo longo encostava nas laterais do cartão */}
      <CardHeader
        title={title}
        subheader={subtitle}
        sx={{ textAlign: "center", pt: 1.5, pb: 0, px: 4 }}
      />
      <Box sx={{ padding: "20px 32px 28px" }}>{children}</Box>
    </Card>
  </Box>
);

// Rodapé de navegação entre as telas de acesso (ex.: "Não tem conta?
// Cadastre-se", "Voltar para o login"). O prefixo em texto neutro e a ação
// em link com peso — o padrão dessas telas no mercado.
export type AuthAltLink = {
  // Texto neutro antes do link (ex.: "Não tem conta?"); opcional
  text?: string;
  // Rótulo do link em destaque (ex.: "Cadastre-se")
  action: string;
  href: string;
};

export const AuthAltLinks = ({ links }: { links: AuthAltLink[] }) => (
  <Box
    sx={{
      marginTop: 2.5,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 1,
    }}
  >
    {links.map((link, index) => (
      <Typography
        key={index}
        variant="body2"
        sx={{ color: colors.textSecondary }}
      >
        {link.text ? `${link.text} ` : ""}
        <Link href={link.href} underline="hover" sx={{ fontWeight: 700 }}>
          {link.action}
        </Link>
      </Typography>
    ))}
  </Box>
);
